module.exports = "\r\n.row{\r\n    padding-top:20px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    /* background: #f3f3f3; */\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/emp-apply-leave/emp-apply-leave.component.css
// module id = ./src/app/hrms/emp-apply-leave/emp-apply-leave.component.css
// module chunks = main